import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SELECTOR_PLAYBACK_HAS_NATIVE_HLS } from 'src/store/reducers/playback';
import { SELECTOR_RESOLUTION_PLAYLIST, SELECTOR_RESOLUTION } from 'src/store/reducers/resolution';
import useUpdateStore from 'src/hooks/useUpdateStore';
import ApplicationService from 'src/services/ApplicationService';
import { IPlaylist } from 'src/interfaces/Playlist';
import { UserEventTriggerName, UserEventTriggerType } from 'src/interfaces/Datahub';
import useTracking from '../useTracking';

export default function useResolution() {
  const { trackUserEventTrigger } = useTracking();
  const playlist = useSelector(SELECTOR_RESOLUTION_PLAYLIST);
  const resolution = useSelector(SELECTOR_RESOLUTION);
  const { updateResolutionInStore } = useUpdateStore();
  const hasNativeHLS = useSelector(SELECTOR_PLAYBACK_HAS_NATIVE_HLS);
  const setResolution = useCallback(
    (resolution: IPlaylist, trigger: UserEventTriggerType) => {
      ApplicationService.player?.setResolution(resolution.label);
      updateResolutionInStore(resolution);
      trackUserEventTrigger({
        trigger,
        event: UserEventTriggerName.CHANGE_RESOLUTION,
      });
    },
    [trackUserEventTrigger, updateResolutionInStore],
  );

  return {
    playlist,
    hasNativeHLS,
    setResolution,
    resolution,
  };
}
